import Icon from '../components/Icon.vue'

Icon.register({"user-circle":{"width":496,"height":512,"paths":[{"d":"M248 8C111 8 0 119 0 256S111 504 248 504 496 393 496 256 385 8 248 8zM248 104C296.6 104 336 143.4 336 192S296.6 280 248 280 160 240.6 160 192 199.4 104 248 104zM248 448C189.3 448 136.7 421.4 101.5 379.8 120.3 344.4 157.1 320 200 320 202.4 320 204.8 320.4 207.1 321.1 220.1 325.3 233.7 328 248 328 262.3 328 276 325.3 288.9 321.1 291.2 320.4 293.6 320 296 320 338.9 320 375.7 344.4 394.5 379.8 359.3 421.4 306.7 448 248 448z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/user-circle.js
// module id = PaGD
// module chunks = 0